import { memo, useEffect, useRef } from 'react';

import { ScaffolderFormPaper } from '../../../components';
import { SyncOptionsInput } from '../components';
import { SyncOption } from '../types';
import { syncOptionsInputErrors } from '../validation';

export interface ApplicationSyncOptionsSectionProps {
  value: SyncOption[];
  onChange: (value: SyncOption[]) => void;
  errors: string[];
}

const ApplicationSyncOptionsSectionInner = ({
  value,
  onChange,
  errors,
}: ApplicationSyncOptionsSectionProps) => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const syncOptionsError =
    errors.length > 0 ? syncOptionsInputErrors(value) : '';

  useEffect(() => {
    if (syncOptionsError) {
      sectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [syncOptionsError]);

  return (
    <div ref={sectionRef}>
      <ScaffolderFormPaper>
        <SyncOptionsInput
          value={value}
          onChange={onChange}
          errors={syncOptionsError ? [syncOptionsError] : []}
        />
      </ScaffolderFormPaper>
    </div>
  );
};

export const ApplicationSyncOptionsSection = memo(
  ApplicationSyncOptionsSectionInner,
);
